export default __webpack_public_path__ + "static/bb-x-bratz-438d8a10984ed8ad7aa55d6d1a2f9c93.webp";